import styled from 'styled-components';

export default styled.div`
  height: 2px;
  background: #29d;
  transition: all 300ms ease;
`;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/Percent.js